export const PLAYER_WHITE = 0;
export const PLAYER_BLACK = 1;



// WEBPACK FOOTER //
// ./src/game/Constants.js